import { Loader2 } from 'lucide-react';

import { cn } from '@/lib/utils';

/**
 * Bloque de carga: tarjeta con spinner y mensaje, centrado.
 *
 * Estaba escrito 19 veces con la misma combinación
 * (`dd-card flex items-center justify-center gap-2 p-8` + `Loader2` girando +
 * un texto atenuado). Nombrarlo evita que la vigésima elija otro padding, y
 * deja un solo lugar donde decidir si algún día pasa a esqueleto.
 *
 * El spinner es una animación FUNCIONAL: comunica una espera real y se detiene
 * cuando llega el dato. No cae bajo la prohibición de movimiento decorativo.
 */
export function LoadingBlock({
  children = 'Cargando…',
  className,
}: {
  /** Mensaje. Decí QUÉ se está cargando: "Cargando perfil…" es mejor que "Cargando…". */
  children?: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'dd-card flex items-center justify-center gap-2 p-8',
        className,
      )}
      role="status"
      aria-live="polite"
    >
      <Loader2 className="text-primary h-4 w-4 animate-spin" aria-hidden />
      <span className="text-fg-muted text-body">{children}</span>
    </div>
  );
}
